'use client'

import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import queryString from 'query-string'

interface ILocation {
  pathname: string
  query: any
  setQueryParams: (newQuery: {}, replace?: boolean) => void
  clearQueryParams: () => void
}

export default function useLocation(): ILocation {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()

  let query = queryString.parse(searchParams.toString())

  const setQueryParams = (
    newQuery: Record<string, any> = {},
    replace: boolean = false,
  ) => {
    const mergedQuery = replace ? newQuery : { ...query, ...newQuery }

    const cleanedQuery = Object.fromEntries(
      Object.entries(mergedQuery).filter(([_, value]) => value !== ''),
    )

    const updatedQuery = queryString.stringifyUrl(
      {
        url: pathname,
        query: cleanedQuery,
      },
      {
        skipNull: true,
        arrayFormat: 'comma',
      },
    )

    router.push(updatedQuery)
  }

  const clearQueryParams = () => router.push(pathname)

  return {
    pathname,
    query,
    setQueryParams,
    clearQueryParams,
  }
}
